import * as React from "react";
import { IBirthdayUser } from "../../../interfaces/IBirthdayUser";
import { IAPersonaSmall } from "./personaSmall/PersonaSmall";
import * as styles from "./ListView.css";
import { Helper } from "../../../Helper";
import { Environment } from "../../../services/Environment";
import { IACardViewService } from "../../messagesCardView/CardView.service";

import { LocalizationService } from "../../../services/LocalizationService";
import { ConditionalOutput } from '../../../services/ConditionalOutput';
import { IEnvironment } from "../../../interfaces/IEnvironment";
import { IFontSlots } from "../../../interfaces/IFontSlots";

export interface IProps {
  users: IBirthdayUser[];
  properties: string[];
  settings: any;
  tenant: string;
  token: string;
  environment: IEnvironment;
  width: number;
  highlightColor: string;
  backgroundColor?: string;
  todayIcon?: string;
  showAnniversaryYear?: boolean;
  isEditMode?: boolean;
  fontSlots?: IFontSlots;
}

export interface IState { }

export class IAListView extends React.Component<IProps, IState> {
  private cardViewService: IACardViewService = new IACardViewService();

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    let users = [];
    // Resizing cards
    const [
      numberOfCardsPerRow,
      maxCardWidthAvailable,
    ] = this.cardViewService.getNumberOfCardsPerRowAndMaxCardWidthAvailable(
      this.props.width,
      20,
      212
    );
    let currentRowNumber = 1;
    let cardsOnPage = 0;

    if (this.props.users && this.props.users.length > 0) {
      this.props.users.forEach((user) => {
        let birthdayString = this.props.settings.isBirthday ? user.birthdayText : user.anniversaryText;
        if (this.props.settings.isBirthday) {
          const userDate = user.birthday.toISOString().split('T')[0].split('-');
          const date = new Date();
          const isBirthdayNextYear = new Date(`${date.getFullYear()}-${userDate[1]}-${userDate[2]}`).getTime() > Date.now();
          const birthDayDate = new ConditionalOutput(`${date.getFullYear()}-${userDate[1]}-${userDate[2]}`)
            .OnCondition(isBirthdayNextYear, `${date.getFullYear() + 1}-${userDate[1]}-${userDate[2]}`)
            .Last();
          const anniversaryYear = Number(birthDayDate.split('-')[0]) - user.birthday.getFullYear();
          birthdayString = new ConditionalOutput(new LocalizationService().strings.Birthday_Years)
            .OnCondition(this.props.settings.isBirthday && !this.props.showAnniversaryYear, user.birthdayText)
            .OnCondition(this.props.settings.isBirthday && this.props.showAnniversaryYear, `${anniversaryYear} ${new LocalizationService().strings.Birthday_Years} - ${user.birthdayText}`)
            .Last();
        }

        let info = (
          <div className={styles.IA_infoTable}>
            {
              <div
                tabIndex={0}
                role="list"
                className={styles.IA_infoTableRow}
              >
                {birthdayString}
              </div>
            }
            {this.props.properties && this.props.properties.length > 0 &&
              this.props.properties.map((property) => {
                return this.convertData(user, property);
              })
            }
          </div>
        );

        // Resizing height on cards
        let cardHeight = 22;
        if (this.props.properties && this.props.properties.length > 0) {
          cardHeight = 22 * (this.props.properties.length + 1);
        }

        const profileImage = Helper.getProfileImageUrlFromImageAPI(
          Environment.getEnvironmentForImageAPI(this.props.environment),
          this.props.tenant,
          this.props.token,
          user.email
        );

        users.push(<IAPersonaSmall
          name={user.name}
          userId={user.guid}
          fontSlots={this.props.fontSlots}
          profileImage={profileImage}
          metadata={info}
          numMetaData={this.props.properties ? this.props.properties.length + 2 : 3}
          listViewStyle={true}
          styles={{
            marginRight: currentRowNumber == numberOfCardsPerRow ? 0 : 20,
            marginBottom: 20,
            width:
              window.innerWidth < 667
                ? window.innerWidth - 56
                : maxCardWidthAvailable,
            maxWidth:
              window.innerWidth < 667 ? window.innerWidth - 56 : 286,
              fontFamily: this.props.fontSlots?.body?.fontFamily
          }}
          highlightColor={this.props.highlightColor}
          todayIcon={this.props.todayIcon}
          isToday={user.isToday}
          cardHeight={numberOfCardsPerRow === 1 ? "auto" : `${cardHeight}px`}
          backgroundColor={this.props.backgroundColor}
          isEditMode={this.props.isEditMode}
          userLoginName={user.email}
        />);

        cardsOnPage++;
        if (
          currentRowNumber == numberOfCardsPerRow ||
          cardsOnPage == this.props.users.length
        ) {
          currentRowNumber = 1;
        } else {
          currentRowNumber++;
        }
        if (cardsOnPage == this.props.users.length) {
          cardsOnPage = 0;
        }
      });
    } else {
      if (this.props.users && this.props.users.length === 0) {
        users.push(<div>{this.props.settings.message}</div>);
      }
    }

    let table = (
      <div>
        <div
          className={styles.IA_birthdayContainer}
          tabIndex={0}
        >
          {users}
        </div>
      </div>
    );

    return table;
  }

  private convertData(user: IBirthdayUser, type: string) {
    let element = undefined;
    switch (type) {
      case "chat":
        if (user.email && user.isToday) {
          element = (
            <div
              className={styles.IA_infoTableRow}
              style={{
                opacity: 0.6
              }}
            >
              <a
                href={`https://teams.microsoft.com/l/chat/0/0?users=${user.email}`}
                style={{ color: this.props.highlightColor }}
              >
                {new LocalizationService().strings.Birthday_chat}
              </a>
            </div>
          );
        }
        break;
      case "email":
        if (user.email && user.isToday) {
          element = (
            <div
              className={styles.IA_infoTableRow}
              style={{
                opacity: 0.6
              }}
            >
              <a href={`mailto:${user.email}`} style={{ color: this.props.highlightColor }}>
                {new LocalizationService().strings.Birthday_email}
              </a>
            </div>
          );
        }
        break;
      case "location":
        if (user.officeLocation) {
          element = (
            <div
              className={[styles.IA_infoTableRow, styles.IA_infoTableText].join(" ")}
              style={{
                opacity: 0.6
              }}
            >
              {user.officeLocation}
            </div>
          );
        }
        break;
      case "jobTitle":
        if (user.jobTitle) {
          element = (
            <div
              className={[styles.IA_infoTableRow, styles.IA_infoTableText].join(" ")}
              style={{
                opacity: 0.6
              }}
            >
              {user.jobTitle}
            </div>
          );
        }
        break;
      case "company":
        if (user.company) {
          element = (
            <div
              className={[styles.IA_infoTableRow, styles.IA_infoTableText].join(" ")}
              style={{
                opacity: 0.6
              }}
            >
              {user.company}
            </div>
          );
        }
        break;
      case "department":
        if (user.department) {
          element = (
            <div
              className={[styles.IA_infoTableRow, styles.IA_infoTableText].join(" ")}
              style={{
                opacity: 0.6
              }}
            >
              {user.department}
            </div>
          );
        }
        break;
      case "phone":
        if (user.phone) {
          element = <div
            className={[styles.IA_infoTableRow, styles.IA_infoTableText].join(" ")}
            style={{
              opacity: 0.6
            }}>
            {user.phone}
          </div>;
        }
        break;
      default:
        element = <div
          className={styles.IA_infoTableRow}
          style={{
            opacity: 0.6
          }}
        >
          {user[type]}
        </div>;
    }
    return element;
  }
}
